const EARTH_RADIUS_MILES = 3958.8;

export function milesBetween(aLat, aLng, bLat, bLng) {
  const toRad = Math.PI / 180;
  const dLat = (bLat - aLat) * toRad;
  const dLng = (bLng - aLng) * toRad;
  const hav =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(aLat * toRad) * Math.cos(bLat * toRad) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(hav));
}

export function driveMinutes(miles) {
  return Math.max(4, Math.round((Number(miles) * 1.4 + 5) / 5) * 5);
}

function formatLegCount(leg) {
  if (leg?.error != null && leg.error !== '') return `ERR ${leg.error}`;
  return String(leg?.count ?? 0);
}

export function formatProcessorTrace(trace = {}) {
  return [
    `CATEGORY butcher_shop → ${formatLegCount(trace.category)}`,
    `TEXT "deer processing" → ${formatLegCount(trace.deerProcessing)}`,
    `TEXT "meat processing" → ${formatLegCount(trace.meatProcessing)}`,
    `DEDUPED ${trace.deduped ?? 0}`,
    `YONA DIRECTORY ${trace.directory ?? 0}`,
  ].join(' · ');
}
